import { useQuery } from '@tanstack/react-query';
import { fetchDirectionalTraffic } from '../apis/directional-traffic';

interface UseDirectionalTrafficParams {
  queryParams?: string;
  enabled?: boolean;
}

const useDirectionalTraffic = ({
  queryParams = '',
  enabled = true,
}: UseDirectionalTrafficParams) => {
  const {
    data: directionalTrafficData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['directionalTraffic', queryParams],
    queryFn: () => fetchDirectionalTraffic(queryParams),
    staleTime: 1000 * 60 * 1,
    enabled,
  });

  return {
    directionalTrafficData,
    isLoading,
    error,
  };
};

export default useDirectionalTraffic;
